import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './toast';
import * as currentBetsService from '../../services/currentBetsService'
import * as apiUserService from '../../services/apiUserService'
import * as userService from '../../services/userService'
import Currency from './currency'
import * as dateUtil from "../../util/date.util"
import * as userUtil from '../../util/user.util';
import Autocomplete from 'react-autocomplete';

let submitFormInterval
let openBets
class EventUnsettledBets extends Component {
   constructor(props) {
      super(props);
      this.state = {
         accounts: "",
         bets_data: [],
         last_id: "",
         first_id: "",
         action: "",
         from: "",
         to: "",
         masterPassword: "",
         page_no: 1,
         count_records: 0,
         records_display: 25,
         loader: true,
         event_id: "",
         client_id: "",
         market_id: "",
         isUserBet: false,
         total_page: 1,
         marketuserDetail: {},
         usermktData: {},
         userBetLock: false,
         userBetDelay: "",

         mkts_name: [],
         marketType: "",
         marketName: "",
         amountFrom: "",
         amountTo: "",
         sportType: "",
         // user_id: "",
         usersList: []
      };
   }
   async componentDidMount() {
      this.setState({ sportType: !!this.props.eventType ? this.props.eventType.name : ''})

      if (this.props.isUserBet) {
         let userData = await apiUserService.getDashboard(this.props.client_id)
         let usermktData = await userService.getUserMarketExposure(this.props.client_id, this.props.market_id);
         usermktData = usermktData.items
         this.setState({
            marketuserDetail: userData,
            userBetDelay: userData.betDelay,
            userBetLock: userData.betLock,
            usermktData: usermktData[0],
            accounts: this.props.accounts,
            event_id: this.props.event_id,
            isUserBet: this.props.isUserBet,
            market_id: this.props.market_id,
            client_id: this.props.client_id
         }, () => { this.submitForm() })
      } else {
         this.setState({ accounts: this.props.accounts, event_id: this.props.event_id }, () => { this.submitForm() })
      }
      // let self = this
      // submitFormInterval = setInterval(function () {
      //    clearInterval(submitFormInterval)
      //    if (self.props.newPopupData) {
      //       self.props.newPopupDataClose()
      //       self.submitForm()
      //    }
      // }, 5000)
   }
   componentWillUnmount(){
      clearInterval(submitFormInterval)
      clearInterval(openBets)
   }
   parseFilterBody() {
      // let body = {
      //    "filters": {
      //       "BetStatuses": ["PLACED", "REQUESTED", "REJECTED"],
      //       "current_user": this.state.accounts,
      //       "user_id": this.state.client_id,
      //       "amount_from": 0.0,
      //       "amount_to": 0.0,
      //       "market_id": this.state.market_id,
      //       "event_id": this.state.event_id,
      //       "competition_id": "",
      //       "sport_type": "",
      //       "market_type": "",
      //    },
      //    "last_id": this.state.last_id,
      //    "first_id": this.state.first_id,
      //    "action": this.state.action,
      //    "from": "",
      //    "to": "",
      //    "page_no": this.state.page_no,
      //    "count_records": this.state.count_records,
      //    "records_display": this.state.records_display
      // }
      let body = {
         "filters":{
             "userId": this.state.client_id,
             "betStatus": ["PLACED", "REQUESTED", "REJECTED"],
             "marketId": this.state.market_id,
             "eventId": this.state.event_id,
             "competitionId": "",
             "sportType": "",
             "marketType": this.state.marketType,
             "amountFrom": this.state.amountFrom,
             "amountTo": this.state.amountTo
         },
         "lastId": this.state.last_id,
         "firstId": this.state.first_id,
         "action": this.state.action,
         "from": "",
         "to": "",
         "countRecords": this.state.count_records,
         "pageNo": this.state.page_no,
         "recordsPerPage": this.state.records_display
     
     }
      body = this.clean(body);
      return body
   }
   async submitForm() {
      const self = this;
      if (this.state.page_no === 1 && this.state.action !== "next" && !this.props.market_id) {
         openBets = setInterval(async function eventOpenBets() {
            clearInterval(openBets)
            if (self.state.page_no === 1 && self.state.action !== "next") {
               let body = self.parseFilterBody()
               currentBetsService.postApiOpenBets(body).then((res) => {
                  if (res.isSuccess) {
                     self.setState(
                        {
                           bets_data: [],
                           last_id: res.lastId,
                           first_id: res.firstId,
                           action: res.action,
                           page_no: res.pageNo,
                           count_records: res.countRecords,
                           total_page: 1,
                           loader: true
                        }, () => {
                           self.setState({
                              bets_data: res.items,
                              total_page: Math.ceil(res.countRecords / self.state.records_display),
                              loader: false
                           })
                        }
                     );
                     openBets = setInterval(eventOpenBets, 5000)
                  }
                  else {
                     self.setState({ loader: false, last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 })
                     openBets = setInterval(eventOpenBets, 5000)
                  }
               })
            }else{
               openBets = setInterval(eventOpenBets, 5000)
            }
         }, 500)
      }

      else {
         let body = self.parseFilterBody()
         currentBetsService.postApiOpenBets(body).then((res) => {
            if (res.isSuccess) {
               self.setState(
                  {
                     bets_data: [],
                     last_id: res.lastId,
                     first_id: res.firstId,
                     action: res.pageNo === 1 ? "" : res.action,
                     page_no: res.pageNo,
                     count_records: res.countRecords,
                     total_page: 1,
                     loader: true
                  }, () => {
                     self.setState({
                        bets_data: res.items,
                        total_page: Math.ceil(res.countRecords / self.state.records_display),
                        loader: false
                     })
                  }
               );
            }
            else {
               self.setState({ loader: false, last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 })
            }
         })
      }
   }

   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   async onUserBetLock(user) {
      if (!this.state.masterPassword) {
         this.props.notify("Please insert master password!", "error");
         return false
      }
      let body = {
         "username": user,
         "masterPassword": this.state.masterPassword
      }
      if (this.state.userBetLock) {
         await userService.blockUser(body).then((res) => {
            if (res.isSuccess) {
               this.props.notify("Bet Locked Succesfully!", "success");
            } else {
               this.props.notify(res.exception.message, "error")
            }
         })
      } else {
         await userService.unBlockUser(body).then((res) => {
            if (res.isSuccess) {
               this.props.notify("Bet Locked Succesfully!", "success");
            } else {
               this.props.notify(res.exception.message, "error")
            }
         })
      }
      this.setState({ masterPassword: "" })
   }
   onAction(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "page_no") {
         this.setState({ [name]: parseInt(value), last_id: "", action: "", first_id: "" }, () => { this.submitForm(); });
      }
      if (name === "last") {
         this.setState({ page_no: this.state.total_page, last_id: "", action: "", first_id: "" }, () => { this.submitForm(); });
      }
      else if (name === "prev" || name === "next" || name === "first") {
         this.setState({ action: name }, () => { this.submitForm(); });
      }
   }

   async onMarketList() {
      this.setState({ marketLoader: true, mkts_name: [], marketName: "" },
         () => {
            currentBetsService.getMarketListByEventName(this.state.event_id, this.state.marketType).then((res) => {
               if (res.isSuccess) {
                  this.setState({ mkts_name: res.items, marketLoader: false });
               }
               else {
                  // this.showToast("No Markets Found!", "error")
                  this.setState({ mkts_name: [], marketLoader: false });
               }
            })
         })
   }
   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.accounts, value)
         let lst = []
         for (let x of res.usersList) {
            lst.push({ label: x, value: x, title: x, name: x })
         }
         lst.sort(function(a, b) {
             if(a.value.toLowerCase() < b.value.toLowerCase()) return -1;
             if(a.value.toLowerCase() > b.value.toLowerCase()) return 1;
             return 0;
         });
         this.setState({ usersList: lst })
      }
      else {
         this.setState({ [name]: value, usersList: [] })
      }
   }
   resetForm() {
      this.setState({ showData: false, client_id: "", usersList: [], marketType: "", marketName: "", mkts_name: [], amountFrom: "", amountTo: "" })
   }
   
   closePopup() {
      this.setState({ bets_data: [], market_id: "", client_id: "", isUserBet: false, last_id: "", first_id: "", action: "", event_id: "", page_no: 1, count_records: 0, records_display: 25 })
      this.props.hidePopupBets()
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   change(e) {
      const name = e.target.name;
      let value = e.target.value;
      this.setState({ [name]: value })
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "marketType" && value !== "") {
         this.setState({ 
            [name]: value, 
            marketName: "" 
         },
            () => {
               this.onMarketList()
            }
         )
      }
      else if (name === "marketType"){
         this.setState({ [name]: value, market_id: "" })
      }
      else {
         this.setState({ [name]: value })
      }
   }
   onPagination() {
      let lst = []
      let total_page = this.state.total_page
      for (let x = 1; x <= total_page; x++) {
         if (this.state.page_no === x || Math.abs(x - this.state.page_no) <= 2 || (this.state.page_no < 3 && x < 6) || (total_page - this.state.page_no < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.page_no === x ? "btn btn-blue active pagewidthpopup" : "btn btn-blue pagewidthpopup"} name="page_no" value={x} onClick={(e) => { this.onAction(e) }}>{x} </button>
            lst.push(htm)
         }
      }
      return lst
   }
   render() {
      let page_no = parseInt(this.state.page_no)
      let count_records = parseInt(this.state.count_records)
      let records_display = parseInt(this.state.records_display)
      let current_record = 0
      let total_record = 0
      let start_record = 0
      if (count_records > (records_display * page_no)) {
         current_record = records_display * page_no
         total_record = count_records
         start_record = current_record - (records_display - 1)
      } else if (this.state.bets_data.length > 0) {
         current_record = count_records
         total_record = count_records
         start_record = ((page_no - 1) * records_display) + 1
      }

      let parent = "";
      if (Object.keys(this.state.marketuserDetail).length > 0) {
         let usr = this.state.marketuserDetail
         for (let pat of usr.parents) {
            if (pat === this.state.accounts) {
               parent += pat
               break
            }
            else {
               parent += pat + " -> "
            }
         }
      }
      let competitionName = !!this.state.usermktData && !!this.state.usermktData.competitionName ? (this.state.usermktData.eventTypeId === '300' ? dateUtil.getBinaryCompetitionDisplayName(this.state.usermktData.competitionName) : this.state.usermktData.competitionName) : ""
      let market_time = !!this.state.usermktData && this.state.usermktData.eventTypeId === '300' ? dateUtil.getBinaryMarketDisplayName(this.state.usermktData.marketName) : []
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="eventunsettle" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-lg modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">{!this.props.isUserBet ? " View More Bet" : " View Bet"}</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body ac-state eventunsettledbets">
                        {!!this.props.isUserBet && <>
                           <div className="market-analysis-user-details mb-3">
                              <fieldset>
                                 <legend>User Details:</legend>
                                 <ul className="row user-datails-popup">
                                    <li className="w-25"><label className="text-left">User Name :</label><span className="text-right">{!!this.state.marketuserDetail && !!this.state.marketuserDetail.username ? this.state.marketuserDetail.username : ""}</span></li>
                                    <li className="w-75 mw100">
                                       <label className="text-left">Parents :</label><span className="text-right"><span className="">{!!this.state.marketuserDetail && !!parent ? parent : ""}</span></span>
                                    </li>
                                    <li className="w-25 mw100">
                                       <label className="text-left">Balance :</label><span className="text-right"><span className="">{!!this.state.marketuserDetail && !!this.state.marketuserDetail.balance ? <Currency amount={this.state.marketuserDetail.balance} showColor={true} /> : ""}</span></span>
                                    </li>
                                    <li className="w-25 mw100">
                                       {/* <label className="text-left">Available Balance :</label><span className="text-right"><span className="">{!!this.state.marketuserDetail && !!this.state.marketuserDetail.availableBalance ? <Currency amount={this.state.marketuserDetail.availableBalance} showColor={true} /> : ""}</span></span> */}
                                       <label className="text-left">Available Balance :</label><span className="text-right"><span className="">{!!this.state.marketuserDetail && !!this.state.marketuserDetail.availableBalance ? <Currency amount={((parseFloat(this.state.marketuserDetail.exposure) + parseFloat(this.state.marketuserDetail.availableBalance) + parseFloat(this.state.marketuserDetail.pnl)))} showColor={true} /> : ""}</span></span>
                                    </li>
                                    <li className="w-25">
                                       <label className="text-left">Exposure :</label><span className="text-right"><span className="">{!!this.state.marketuserDetail && !!this.state.marketuserDetail.exposure ? <Currency amount={this.state.marketuserDetail.exposure} showColor={true} /> : ""}</span></span>
                                    </li>
                                    <li className="w-25">
                                       <label className="text-left">P&amp;L :</label><span className="text-right"><span className="">{!!this.state.marketuserDetail && (!!this.state.marketuserDetail.upLineBalance || !!this.state.marketuserDetail.downLineBalance) ? <Currency amount={(this.state.marketuserDetail.upLineBalance + this.state.marketuserDetail.downLineBalance)} showColor={true} /> : "0"}</span></span>
                                    </li>
                                    <li className="w-25">
                                       <label className="text-left">Bet Lock :</label>
                                       <span>
                                          <label className="checkboxx">
                                             <input type="checkbox" checked={this.state.userBetLock} onChange={() => { this.setState({ userBetLock: !this.state.userBetLock }) }} />
                                             <span className="checkmark1" style={{ top: "-14px" }}></span>
                                          </label>
                                       </span>
                                    </li>
                                    {/* <li className="w-20 my-auto">
                                       <label className="text-left">Bet Delay :</label><span className="text-right"><input type="number" className="form-control d-inline w-25" id="userBetDelay" name="userBetDelay" onChange={(e) => { this.onChange(e) }} value={this.state.userBetDelay} /></span>
                                    </li> */}
                                    <li className="w-75 my-auto">
                                       <label className="text-left">Master Password :</label>
                                       <span className="text-right">
                                          <input type="password" className="form-control d-inline w-30" id="masterPassword" name="masterPassword" value={this.state.masterPassword} onChange={(e) => { this.onChange(e) }} />
                                       </span>
                                       <button type="button" className="btn btn-primary btn-sm ml-2 mt--4" data-dismiss="modal" onClick={() => { this.onUserBetLock(this.state.marketuserDetail.username) }}>Confirm</button>
                                    </li>
                                 </ul>
                              </fieldset>
                           </div>
                           <div className="market-analysis-user-market-details mb-3 eventunsettledbets">
                              <fieldset>
                                 <legend>Market Details:</legend>
                                 <ul className="row user-market-popup">
                                    <li className="w-25"><label className="text-left">Competition Name :</label><span className="text-right">{competitionName}</span></li>
                                    <li className="w-75 mw100">
                                       <label className="text-left">Event Name :</label><span className="text-right"><span className="">{!!this.state.usermktData && !!this.state.usermktData.eventName ? this.state.usermktData.eventName : ""}</span></span>
                                    </li>
                                    <li className="w-25 mw100">
                                       <label className="text-left">Market Name :</label><span className="text-right"><span className="">{!!this.state.usermktData && !!this.state.usermktData.marketName ? (this.state.usermktData.eventTypeId === '300' && !!market_time && market_time.length > 0 ? <>
                                                            {market_time[0] }
                                                            <span className=''> [<b>{(market_time.length > 0 ? market_time[1] : "")}</b>]</span>
                                                            </> 
                                                            : this.state.usermktData.marketName) : ""}</span></span>
                                    </li>
                                    <li className="w-25">
                                       <label className="text-left">Order Count:</label><span className="text-right"><span className="">{!!this.state.usermktData && !!this.state.usermktData.orderCount ? this.state.usermktData.orderCount : ""}</span></span>
                                    </li>
                                    <li className="w-25">
                                       <label className="text-left">Total Amount :</label><span className="text-right"><span className="">{!!this.state.usermktData && !!this.state.usermktData.totalAmount ? this.state.usermktData.totalAmount : ""}</span></span>
                                    </li>
                                    <li className="w-25">
                                       <label className="text-left">Max Profit :</label><span className="text-right"><span className="">{!!this.state.usermktData && !!this.state.usermktData.maxProfit ? this.state.usermktData.maxProfit : ""}</span></span>
                                    </li>
                                 </ul>
                              </fieldset>
                           </div>
                        </>
                        }

                        {!this.props.isUserBet &&
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                              <label className="mb-0 font-12">Search By Client</label>
                                 <div className="form-group font-12 autocomplete-wrapper">                                 
                                    <Autocomplete
                                       value={this.state.client_id}
                                       items={this.state.usersList}
                                       getItemValue={item => item.title}
                                       renderItem={(item, isHighlighted) =>
                                          <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                             {item.title}
                                          </div>
                                       }
                                       inputProps={{ placeholder: 'Search by client' }}
                                       name="client_id"
                                       onChange={(event, client_id) => this.onUserSearch(event, "client_id", client_id)}
                                       onSelect={client_id => this.setState({ client_id })}
                                    />
                                 </div>
                              </div>
                           <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                              <div className="form-group font-12">
                                 <label className="mb-0 pb-1 mt-1">Select Market Type</label>
                                 <select title="Market Type" className="form-control" name="marketType" value={this.state.marketType} onChange={(e) => { this.onChange(e) }} disabled={(this.state.sportType !== "LOTUS" && this.state.sportType !== "SUPERNOVA" && this.state.sportType !== "DRC") ? false : true}>
                                    <option value="">Select Market Type</option>
                                    {(this.state.sportType === "Cricket" || this.state.sportType === "Football" || this.state.sportType === "Tennis") && <option value="ODDS">Odds</option>}
                                    {(this.state.sportType === "Cricket" || this.state.sportType === "Football" || this.state.sportType === "Tennis" || this.state.sportType === "Election" || this.state.sportType === "Kabaddi") && <option value="BOOKMAKER">Bookmaker</option>}
                                    {(this.state.sportType === "Cricket" || this.state.sportType === "Election") && <option value="LINE">Fancy</option>}
                                    {/* {this.state.sportType === "Football" && <option value="OVER_UNDER_05">Over/Under 0.5 Goals</option>}
                                    {this.state.sportType === "Football" && <option value="OVER_UNDER_25">Over/Under 2.5 Goals</option>}
                                    {this.state.sportType === "Football" && <option value="OVER_UNDER_15">Over/Under 1.5 Goals</option>}
                                    {this.state.sportType === "Football" && <option value="OVER_UNDER_35">Over/Under 3.5 Goals</option>}
                                    {(this.state.sportType === "HorseRacing" || this.state.sportType === "GreyhoundRacing" || this.state.sportType === "Election") && <option value="WIN">Win</option>}
                                    {this.state.sportType === "Binary" && <option value="DAILY">Daily</option>}
                                    {this.state.sportType === "Binary" && <option value="1_HOUR">1 Hour</option>}
                                    {this.state.sportType === "Binary" && <option value="2_HOUR">2 Hour</option>} */}
                                 </select>
                              </div>
                           </div>

                           <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                              <div className="form-group font-12">
                                 <label className="mb-0 pb-1 mt-1">Select Market</label>
                                 <div className="input-group">
                                    <select title="Market" className="form-control" name="market_id" value={this.state.market_id} onChange={(e) => { this.onChange(e) }} disabled={this.state.marketType !== "" ? false : true}>
                                       <option value="">Select Market</option>
                                       {this.state.mkts_name.length > 0 ? this.state.mkts_name.map((mkt, i) => <option key={mkt.marketId + "_" + i} value={mkt.marketId}>{mkt.marketName}</option>) : ""}
                                    </select>
                                    {this.state.marketLoader &&
                                       <span className="input-group-addon">
                                          <i className="fa fa-refresh fa-spin"></i>
                                       </span>
                                    }
                                 </div>
                              </div>
                           </div>
                               
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                     <div className="form-group font-12">
                                       <label className="mb-0 pb-1 mt-1">Amount From</label>
                                        <input className="form-control  d-inline-block"  value={this.state.amountFrom} name="amountFrom" onChange={(e) => { this.onChange(e) }} type="number" placeholder="Amount From" />
                                     </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                     <div className="form-group font-12">
                                       <label className="mb-0 pb-1 mt-1" >Amount To</label>
                                        <input className="form-control  d-inline-block" value={this.state.amountTo} name="amountTo" onChange={(e) => { this.onChange(e) }} type="number" placeholder="Amount To" />
                                     </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="btn-group mt-4" role="group" aria-label="Basic example" id="divpagecount">
                                    <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                 </div>
                              </div>
                        </div>
                        }

                        <div className="row">
                           <div className="col-12">
                              <div className="table-responsive">
                                 <table id="example" className="table table-bordered font-14 tab-ttoptip whitespace">
                                    <thead>
                                       <tr>
                                          <td>User Name</td>
                                          <td>Distributor</td>
                                          <td>Market</td>
                                          <td>Runner</td>
                                          <td>Side</td>
                                          <td className="text-right">Line</td>
                                          <td className="text-right">Rate</td>
                                          <td className="text-right">Amount</td>
                                          <td title="Potential Profit" className="text-right">PP</td>
                                          <td title="Potential Loss" className="text-right">PL</td>
                                          <td>Time</td>
                                          <td>IP</td>
                                          <td>Device</td>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       {!!this.state.loader ?
                                          <tr>
                                             <td colSpan={15} align="center">
                                                Loading......
                                                    </td>
                                          </tr> :
                                          this.state.bets_data.length > 0 ? this.state.bets_data.map((order, i) => {
                                             let st = (order.createdAt).split(" ")
                                             let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                             let dt = new Date(dtstr).toLocaleString("hi-IN")
                                             let price = order.price
                                             {/* let market_time = order.eventTypeId === '300' ? dateUtil.getBinaryMarketDisplayName(order.marketName):[] */}
                                             return (
                                                <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : ""}>
                                                   <td>{order.username ? order.username : "-"}</td>
                                                   <td>{order.parents ? userUtil.getAppropriateParent(order.parents, this.state.accounts): "-"}</td>
                                                   <td>{order.eventTypeId === '300' && !!market_time && market_time.length > 0 ? 
                                                            <>
                                                            {market_time[0] }
                                                            <span className=''> [<b>{(market_time.length > 0 ? market_time[1] : "")}</b>]</span>
                                                            </>
                                                            
                                                            : !!order.marketName ? order.marketName : "-"}</td>
                                                   <td>{!!order.runnerName ? order.runnerName : "-"}</td>
                                                   <td>{order.side === 0 ? "Back" : order.side === 1 ? "Lay" : order.side === -1 ? "Unknown" : "-"}</td>
                                                   <td className="text-right fbold">{order.marketBettingType === "LINE" && !!order.runnerId ? order.runnerId : "-"}</td>
                                                   <td className="text-right fbold">{!!price ? price : "0.00"} </td>
                                                   <td className="text-right fbold">{!!order.amount ? <Currency className="fbold" amount={order.amount} showColor={false} /> : "-"}</td>
                                                   <td className="text-right fbold">{!!order.potentialProfit ? <Currency className="fbold text-green" amount={order.potentialProfit} showColor={false} /> : "-"}</td>
                                                   <td className="text-right fbold">{!!order.potentialLoss ? <Currency className="fbold text-red" amount={order.potentialLoss} showColor={false} /> : "-"}</td>
                                                   <td title={!!dt ? dt : "-"}>{!!dt ? dt : "-"}</td>
                                                   <td>{!!order.clientIp ? order.clientIp : "-"}</td>
                                                   <td>{order.device === 0 ? "UNKNOWN" : order.device === 1 ? "DESKTOP" : order.device === 2 ? "MOBILE" : "-"}</td>
                                                </tr>
                                             );
                                          }) : <tr>
                                             <td colSpan={25} align="center">
                                                No Data Found.
                                                      </td>
                                          </tr>}

                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="modal-footer">
                        <div className="row w-100">
                           <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {start_record} - {current_record} of {total_record} entries</span></div>
                           <div className="col-12 col-sm-12 col-md-6">
                              <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                 <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" && this.state.page_no === 1 ? true : false}>First</button>
                                 <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" && this.state.page_no === 1 ? true : false}>Prev</button>
                                 {this.onPagination()}
                                 <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" && this.state.page_no === this.state.total_page ? true : false}>Next</button>
                                 <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" && this.state.page_no === this.state.total_page ? true : false}>Last</button>
                              </div>
                           </div>
                        </div>
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.closePopup() }}></div>
            </div>
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(EventUnsettledBets);